import { MyProfile } from '@features/profile';
import styles from './Profile.module.css';

export default function Profile(): React.ReactElement {
    return (
        <div className={styles.container}>
            <MyProfile />
        </div>
    );
}
